<template>
	<div class="p-col-12 p-grid">

		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayer2ImageUrl()" alt="" style="width: 90%; margin: auto">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Players</p>
			<p class="login-subtitle">Meet Intelligent Agents</p>
			<p class="login-text justified">A smart tool that evaluates your worth, spots opportunities, and fast-tracks negotiations with clubs. </p>
			<p class="login-text justified">This advanced algorithm boosts your chances of a successful deal</p>
			<p class="login-text justified">Sign up now and enjoy the following perks: a targeted strategy for your football future, time-saving negotiations, and uninterrupted seasons.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-6 button-box' : 'p-lg-4 button-box'" style="padding: 0px">
				<Button label="Represent yourself with TiroLibre" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>

		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayer2ImageUrl()" alt="" style="width: 90%; margin: auto">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-10 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Represent yourself with TiroLibre" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>

</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>